class BDProductMedia extends HTMLElement {
  connectedCallback() {
    const grid = this.closest('[data-product-grid-content]');
    if (!grid) return;

    const sectionEl = this.closest('[data-section-id]');
    if (!sectionEl) return;

    this.sectionId = sectionEl.dataset.sectionId;
    this.eventName = `pdp:section-${this.sectionId}:change-variant`;

    this._onVariantUpdate = this.handleVariantUpdate.bind(this);

    // Wait for theme core if it hasn't loaded yet
    if (window.themeCore && window.themeCore.EventBus) {
      this.attachEventBusListener();
    } else {
      window.addEventListener('DOMContentLoaded', this.attachEventBusListener.bind(this), { once: true });
    }

    this.addEventListener('click', (e) => {
      const zoomEl = e.target.closest('[data-zoom]');
      if (!zoomEl) return;

      this.#openLightboxFromZoom(zoomEl);
    });
  }

  attachEventBusListener() {
    if (!window.themeCore || !window.themeCore.EventBus) {
      console.warn('BDProductMedia: themeCore.EventBus not found.');
      return;
    }
    window.themeCore.EventBus.listen(this.eventName, this._onVariantUpdate);
    console.log('BDProductMedia: listener attached to EventBus for', this.eventName);
  }

  disconnectedCallback() {
    // The theme's EventBus might not have a standard `remove` method exposed based on the minified code.
    // Leaving this empty is usually fine for product pages.
    if (window.themeCore?.EventBus?.remove && this.eventName && this._onVariantUpdate) {
      window.themeCore.EventBus.remove(this.eventName, this._onVariantUpdate);
    }
  }

  handleVariantUpdate(data) {
    console.log('VARIANT UPDATE FIRED', data);

    // The theme's EventBus passes an object with variantId directly
    const variantId = data?.variantId || data?.variant?.id;

    console.log('Resolved variantId:', variantId);

    if (!variantId) {
      console.warn('BDProductMedia: Could not resolve variantId');
      return;
    }

    // Skip fetching on the very first initialization to save a network request
    // since the correct images are already rendered by Shopify on page load.
    if (data?.firstInitialization) {
      console.log('BDProductMedia: Skipping fetch on first initialization');
      return;
    }

    this.fetchUpdatedMediaSection(variantId);
  }

  async fetchUpdatedMediaSection(variantId) {
    console.log('fetch', variantId);
    const sectionId = this.sectionId; // Use cached sectionId
    if (!sectionId) {
      console.warn('BDProductMedia: No section_id found');
      return;
    }

    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
    console.log('BDProductMedia: Fetching own section:', url);

    const response = await fetch(url);
    if (!response.ok) return;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const updated = doc.querySelector('bd-product-media');
    if (!updated) {
      console.warn('BDProductMedia: Updated media not found in fetched HTML');
      return;
    }

    this.updateFromHtml(updated);
  }

  updateFromHtml(updated) {
    // Fade out
    this.classList.add('is-updating');

    requestAnimationFrame(() => {
      setTimeout(() => {
        // Destroy old slider
        this.querySelector('bd-slider')?.destroySlider?.();

        // Swap HTML
        this.innerHTML = updated.innerHTML;

        // Re-init slider
        const slider = this.querySelector('bd-slider');
        slider?.initSlider?.();

        // Reset Embla to index 0
        slider?.embla?.scrollTo(0, false);

        // ⭐ Bind loaders AFTER DOM swap
        if (typeof bindMediaLoaders === 'function') {
          bindMediaLoaders(this);
        }

        // Fade in
        requestAnimationFrame(() => {
          this.classList.remove('is-updating');
        });
      }, 150);
    });
  }

  #openLightboxFromZoom(zoomEl) {
    const slider = this.querySelector('bd-slider');
    const lightbox = document.querySelector('bd-lightbox'); // ⭐ updated

    if (!slider || !lightbox) return;

    const slides = slider.embla.slideNodes();

    const images = slides.map(s => {
      const img = s.querySelector('[data-zoom] img');
      return img?.dataset.zoomSrc || img?.src;
    });

    const index = slides.findIndex(s => s.contains(zoomEl));

    lightbox.open(images, index);
  }
}

customElements.define('bd-product-media', BDProductMedia);